import styles from './card.module.css';

/**
 * @return {jsx}
 **/
export const Card = ({
  checked = false,
  description = null,
  icon = null,
  label = '',
  name = '',
  value = '',
  onChange,
  ...props
}) => {
  return (
    <label className={`${styles.cardContainer} ${checked ? styles.cardContainerSelected : ''}`} {...props}>
      <input
        type='radio'
        name={name}
        value={value}
        className={styles.cardInput}
        checked={checked}
        onChange={onChange}
      />
      <div className={styles.titleContainer}>
        <div className={styles.iconContainer}>
          {icon}
        </div>
        <h3 className={styles.cardTitle}>{label}</h3>
      </div>
      <p className={`${styles.descriptionText}`}>{description}</p>
    </label>
  );
};

export default Card;
